import CustomClientError from 'src/Member/errorhandling/CustomClientError';
import useAccountUnlockVerifyLink from './hooks/useAccountUnlockVerifyLink';
import { Col, Container, Row } from 'react-bootstrap';
import { PageNotFoundSVG } from 'src/Member/img/ServerErrorSVG';

const AccountUnlockVerifyLink = () => {
  const { isLoading, serverError, forcePassword, OTPRequired, headingRef } =
    useAccountUnlockVerifyLink();
  return isLoading ? (
    <div></div>
  ) : serverError ? (
    <Container className="page-not-found">
      <Row>
        <Col className="text-center no-data-found-component">
          <div className="page-not-found-container">
            <PageNotFoundSVG />
            <div className="content-box">
              <div
                role="heading"
                aria-level={1}
                className="sr-only"
                tabIndex={-1}
                ref={headingRef}
              >
                Page Not Found
              </div>
              <h1 aria-hidden={true} role="alert">
                Page Not Found
              </h1>
              <p role="alert">
                {`It looks like the link you followed is broken or no longer available. Contact Customer Support Team for further information.
${' '}`}
              </p>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  ) : (
    <></>
  );
};

export default AccountUnlockVerifyLink;
